import { AppRouteProps } from "@harea/component";
import React from "react";

const EstablishmentsContainer = React.lazy(() => import('./containers/UserOrganisationSitesList'))

export const EstablishmentsRoutes: Array<AppRouteProps> = [
    {
        path: 'establishments',
        title: "Generic.UserOrganisation.Sites.title",
        element: <EstablishmentsContainer />
    }
]
